<!--
 * @Author: zl
 * @Date: 2022-09-15 15:38:33
 * @LastEditTime: 2022-09-16 16:14:02
 * @LastEditors: zl
 * @Description: 工 程 联 系 单
-->
<template>
	<div class='ContactList-layout'>
		<el-row>
			<el-col :span="22"
					:offset="1">
				<h2 class="text-center mb30">工 程 联 系 单</h2>
				<el-descriptions :column="2"
								 size="small"
								 border
								 class="custom-descriptions">
					<template slot="extra">
						编号：{{ form.serialNo }}
					</template>
					<el-descriptions-item label="工程项目名称"
										  :span="2">{{ currentObj.proName }}</el-descriptions-item>
					<el-descriptions-item label="关联审计任务"
										  :span="2">{{ form.taskName }}</el-descriptions-item>
					<el-descriptions-item label="主题"
										  :span="2">{{ form.title }}</el-descriptions-item>
					<el-descriptions-item label="性质"
										  :span="2">
						{{ dealType(form.type) }}
					</el-descriptions-item>
					<el-descriptions-item label="施工单位意见"
										  :span="2"
										  contentClassName="h200">{{ form.roadContent }}</el-descriptions-item>
					<el-descriptions-item label="施工单位"
										  :span="2">{{ form.roadSign }}</el-descriptions-item>
					<el-descriptions-item label="项目负责人">{{ form.roadPrincipal }}</el-descriptions-item>
					<el-descriptions-item label="日期">
						{{ form.roadDate ? form.roadDate.substr(0, 10) : '' }}
					</el-descriptions-item>
					<el-descriptions-item label="监理单位意见"
										  :span="2"
										  contentClassName="h200">{{ form.supContent }}</el-descriptions-item>
					<el-descriptions-item label="监理单位"
										  :span="2">{{ form.supSign }}</el-descriptions-item>
					<el-descriptions-item label="项目负责人">{{ form.supPrincipal }}</el-descriptions-item>
					<el-descriptions-item label="日期">
						{{ form.supDate ? form.supDate.substr(0, 10) : '' }}
					</el-descriptions-item>
					<el-descriptions-item label="设计单位意见"
										  :span="2"
										  contentClassName="h200">{{ form.desContent }}</el-descriptions-item>
					<el-descriptions-item label="设计单位"
										  :span="2">{{ form.desSign }}</el-descriptions-item>
					<el-descriptions-item label="项目负责人">{{ form.desPrincipal }}</el-descriptions-item>
					<el-descriptions-item label="日期">
						{{ form.desDate ? form.desDate.substr(0, 10) : '' }}
					</el-descriptions-item>
					<el-descriptions-item label="建设单位意见"
										  :span="2"
										  contentClassName="h200">{{ form.devContent }}</el-descriptions-item>
					<el-descriptions-item label="建设单位"
										  :span="2">{{ form.devSign }}</el-descriptions-item>
					<el-descriptions-item label="项目负责人">{{ form.devPrincipal }}</el-descriptions-item>
					<el-descriptions-item label="日期">
						{{ form.devDate ? form.devDate.substr(0, 10) : '' }}
					</el-descriptions-item>
					<el-descriptions-item label="其他单位意见"
										  :span="2"
										  contentClassName="h200">{{ form.otherContent }}</el-descriptions-item>
					<el-descriptions-item label="其他单位"
										  :span="2">{{ form.otherSign }}</el-descriptions-item>
					<el-descriptions-item label="项目负责人">{{ form.otherPrincipal }}</el-descriptions-item>
					<el-descriptions-item label="日期">
						{{ form.otherDate ? form.otherDate.substr(0, 10) : '' }}
					</el-descriptions-item>
					<el-descriptions-item label="上传附件"
										  :span="2">
						<myUpload listType="list"
								  tableName="audit_contact_sheet"
								  uploadType="2"
								  assortment="testaa"
								  width="auto"
								  height="auto"
								  :aid="form.id"
								  mode="view"
								  class="h100 w100"></myUpload>
					</el-descriptions-item>
				</el-descriptions>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import * as API from '@/api/AuditReport/AuditReport'
export default {
	props: {
		currentObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},
	data() {
		return {
			form: {},
		}
	},
	created() {
		// 获取详情
		this.getDetails()
	},
	mounted() {},
	methods: {
		// 获取详情
		getDetails() {
			API.selectContactSheetDetail({
				id: this.currentObj.id,
			}).then((res) => {
				this.form = res.data
			})
		},

		// 处理类型
		dealType(data) {
			let msg = ''
			switch (data) {
				case 0:
					msg = '通知'
					break
				case 1:
					msg = '建议'
					break
				case 2:
					msg = '联系'
					break
				case 3:
					msg = '备忘'
					break
			}
			return msg
		},
	},
	computed: {},
}
</script>

<style lang='less' scoped>
</style>